const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_UNIT_OFFER':
      return {
        ...state,
        unitOffers: action.unitOffers,
      };

    default:
      return state;
  }
};
